<template>
  <banners
    :sticky-top="true"
    :narrow="true"
  >
    <div class="flex h-[calc(100vh-52px)] w-full">
      <div
        :class="{
          'relative w-[900px] overflow-scroll': isDesktop,
          'w-full': !isDesktop,
          'pb-14': !isLoadBoard,
        }"
      >
        <div class="mx-4 mb-3 mt-6 bg-white">
          <div class="container-max m-auto">
            <div class="flex items-center justify-between">
              <router-link
                :to="backUrl"
                title="Back to Loads"
                class="-ml-2 flex max-w-[66%] items-center"
              >
                <svg
                  class="min-w-7"
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 10.8906L13 16.8906L19 22.8906"
                    stroke="#313545"
                    stroke-width="2"
                  />
                </svg>
                <p
                  v-if="isLoadBoard"
                  class="overflow-hidden text-ellipsis whitespace-nowrap text-2xl"
                >
                  {{ isDesktop ? 'Load ' : ''
                  }}{{ load?.external_order_or_load_number }}
                </p>
                <p
                  v-else
                  class="overflow-hidden text-ellipsis whitespace-nowrap text-2xl"
                >
                  {{ isDesktop ? 'Load ' : '' }}{{ load?.shipment_identifier }}
                </p>
              </router-link>

              <div v-if="!isLoadBoard && !isLoading">
                <p
                  class="rounded-full px-2 text-sm capitalize"
                  :class="{
                    'bg-yellow-100 text-yellow-700': load.status === 'covered',
                    'bg-blue-100 text-blue-500': load.status === 'progress',
                    'bg-green-100 text-green-800':
                      load.status === 'assumed_delivered',
                    'bg-red-150 text-red-500':
                      load.status === 'assign_vehicle' ||
                      load.status === 'available',
                  }"
                >
                  {{ formatLoadStatus(load.status) }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isLoading"
          class="mt-6"
        >
          <img
            class="loading m-auto h-12 w-12"
            src="@/assets/loading-v2-yellow.svg"
            alt="loading spinner"
          />
        </div>
        <div v-else-if="currentTab === 'Details'">
          <LoadDetailMap
            v-if="!loadDetailsLoading && !isDesktop"
            :load="load"
          ></LoadDetailMap>

          <div class="bg-light-gray px-4 pb-8 lg:bg-white lg:pb-0">
            <div class="container-max m-auto flex min-h-[80vh] flex-col gap-4">
              <div
                v-if="isLoadBoard"
                :class="{
                  'z-10 -mt-8 lg:mt-4': !isDesktop,
                }"
              >
                <div
                  v-if="placed_offer?.id && bookNowPreview"
                  class="mb-3 flex gap-2 rounded-md border border-ocean-400 bg-ocean-100 p-3"
                >
                  <img
                    class="flex h-6 w-6 items-center text-2xs"
                    src="@/assets/alert-circle.svg"
                    alt="alert icon"
                  />

                  <div class="flex flex-col items-start">
                    <p class="text-lg">
                      {{
                        placed_offer?.status === 'accepted'
                          ? 'Load Booked'
                          : 'Offer Placed'
                      }}
                    </p>
                    <p
                      v-if="placed_offer?.status === 'accepted'"
                      class="text-left font-normal text-steel-900"
                    >
                      You booked this load on
                      {{ dayjs(placed_offer?.created_at).format('MM/DD/YYYY') }}
                      for {{ formatPrice(placed_offer.rate, 0) }}.
                    </p>
                    <p
                      v-else
                      class="text-left font-normal text-steel-900"
                    >
                      You placed an offer on this load on
                      {{ dayjs(placed_offer?.created_at).format('MM/DD/YYYY') }}
                      for {{ formatPrice(placed_offer.rate, 0) }}.
                    </p>

                    <!-- <div class="flex gap-12 pl-4 pt-4">
                      <button class="text-ocean-800">Edit Offer</button>
                      <button
                        class="text-ocean-800"
                        @click="handleWithdrawOffer"
                      >
                        Withdraw Offer
                      </button>
                    </div> -->
                  </div>
                </div>

                <div
                  :class="{
                    'rounded-xl border border-light-gray bg-white px-4 py-2 shadow-md lg:mt-4':
                      !isDesktop,
                  }"
                >
                  <div
                    :class="{
                      'rounded-lg border border-light-gray px-3': isDesktop,
                    }"
                  >
                    <div
                      v-if="isDesktop"
                      class="mt-4 flex flex-col items-start gap-2"
                    >
                      <span
                        v-if="lane_prediction && loadRateText"
                        class="rounded px-2 py-1 text-xs"
                        :class="loadRateClass"
                        >{{ loadRateText }}</span
                      >
                      <div class="flex items-end gap-1">
                        <h3 class="text-3xl font-semibold">
                          {{ formatPrice(load.price) }}
                        </h3>
                        <p
                          v-if="ratePerMile && load?.price"
                          class="mb-[6px] w-max text-2xs text-neutral-subtlest"
                        >
                          {{ ratePerMile }}/mi
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="!isDesktop"
                      class="flex justify-between"
                    >
                      <!-- <div>
                      <a
                        :href="`/broker/carriers/${load?.carrier?.id}`"
                        target="_blank"
                        class="load-highway-badge flex gap-2"
                      >
                        <img
                          v-if="brokerLogo"
                          class="flex h-8 items-center text-2xs"
                          :src="brokerLogo"
                          alt="broker logo"
                        />
                        <div
                          v-else
                          class="h-2"
                        ></div>
                      </a>
  
                      <p
                        class="mb-2 text-left text-1xs font-normal text-neutral-subtlest"
                      >
                        This load is eligible for an Advance and QuickPay
                      </p>
                    </div> -->

                      <div class="flex flex-col items-start">
                        <span
                          v-if="loadRateText"
                          class="rounded px-2 py-1 text-xs"
                          :class="loadRateClass"
                          >{{ loadRateText }}</span
                        >

                        <div class="flex items-end gap-2 pt-2">
                          <h3 class="text-3xl font-semibold">
                            {{ formatPrice(load.price) }}
                          </h3>
                          <p
                            v-if="ratePerMile && load?.price"
                            class="-mt-2 text-1xs text-neutral-subtlest"
                          >
                            {{ ratePerMile }}/mi
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="my-4 flex items-center justify-between">
                      <!-- <a
                      v-if="isDesktop"
                      :href="`/broker/carriers/${load?.carrier?.id}`"
                      target="_blank"
                      class="flex items-center justify-center gap-2"
                    >
                      <HighwayConnectBadge
                        :is-carrier-registered="load?.carrier?.is_registered"
                      ></HighwayConnectBadge>
  
                      <img
                        v-if="brokerLogo"
                        class="flex h-8 max-w-48 items-center text-2xs"
                        :src="brokerLogo"
                        alt="broker logo"
                      />
                    </a> -->

                      <div
                        v-if="billableMiles"
                        class="flex gap-1"
                      >
                        <img
                          src="@/assets/loads/map.svg"
                          alt="map icon"
                        />
                        <p class="text-xs sm:text-sm">
                          {{ billableMiles }} mi Trip
                        </p>
                      </div>

                      <div class="flex items-center gap-1">
                        <img
                          class="h-5 w-5"
                          src="@/assets/loads/destination-marker.svg"
                          alt="destination icon"
                        />
                        <p class="text-xs sm:text-sm">
                          {{ numberOfStops }}
                        </p>
                      </div>

                      <div class="flex items-center gap-1 sm:gap-2">
                        <img
                          class="h-4 w-4"
                          src="@/assets/phone-arrow.svg"
                          alt="phone icon"
                        />
                        <a
                          v-if="formattedPhone"
                          class="text-xs sm:text-sm"
                          :href="`tel:+${load.broker_phone_number}`"
                        >
                          {{ formattedPhone }}
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>

                    <div v-if="lane_prediction">
                      <img
                        class="mb-4 mt-2 text-2xs"
                        src="@/assets/loads/triumph-intelligence.svg"
                        alt="triumph logo"
                      />

                      <div class="mb-8 mt-1">
                        <div class="mb-2 flex justify-between">
                          <div>
                            <p
                              class="text-sm font-normal text-neutral-subtlest"
                            >
                              Low:
                              {{
                                formatPrice(lane_prediction?.low_buy_rate)
                              }}/mi
                            </p>
                          </div>
                          <div>
                            <p
                              class="text-sm font-normal text-neutral-subtlest"
                            >
                              High:
                              {{
                                formatPrice(lane_prediction?.high_buy_rate)
                              }}/mi
                            </p>
                          </div>
                        </div>

                        <div class="relative flex gap-[2px]">
                          <span
                            v-if="isBelowMarket"
                            class="flex h-4 w-1/12 rounded-l-md bg-red-500"
                          ></span>
                          <span
                            class="flex h-4 w-2/12 bg-[#2AC6E8]"
                            :class="{
                              'rounded-l-md': !isBelowMarket,
                            }"
                          ></span>
                          <span
                            class="flex h-4 bg-[#18A5CB]"
                            :class="
                              isBelowMarket || isAboveMarket
                                ? 'w-7/12'
                                : 'w-8/12'
                            "
                          ></span>
                          <span
                            class="flex h-4 w-2/12 bg-[#136782]"
                            :class="{
                              'rounded-r-md': !isAboveMarket,
                            }"
                          ></span>
                          <span
                            v-if="isAboveMarket"
                            class="flex h-4 w-1/12 rounded-r-md bg-green-900"
                          ></span>

                          <div
                            v-if="load?.rate_per_mile"
                            class="absolute -bottom-4 flex h-5 w-5 flex-col items-center"
                            :style="`left: calc(${targetRatePercentage}% - 10px)`"
                          >
                            <img
                              class="h-5 w-5"
                              src="@/assets/loads/orange-arrow.svg"
                              alt="arrow"
                            />
                          </div>
                          <p
                            v-if="load?.rate_per_mile"
                            class="absolute -bottom-8 min-w-max text-sm leading-none"
                            :style="`left: calc(${targetRatePercentage}% - 24px)`"
                            :class="{
                              'ml-4': targetRatePercentage < 10,
                              '-ml-8': targetRatePercentage >= 95,
                              '-ml-2':
                                targetRatePercentage >= 85 &&
                                targetRatePercentage < 95,
                            }"
                          >
                            {{ ratePerMile }}/mi
                          </p>
                        </div>
                      </div>

                      <div class="mb-6 mt-10 flex flex-col items-start gap-2">
                        <!-- <div
                          class="flex items-center rounded-lg bg-light-gray px-2 py-1 text-sm font-normal text-neutral-subtle"
                        >
                          <img
                            class="mr-2 h-5 w-5"
                            src="@/assets/loads/load-pay.svg"
                            alt="triumph logo"
                          />
                          Cash Advance - 3.5%
                        </div> -->
                        <div
                          v-if="quickPayRate"
                          class="flex items-center rounded-lg bg-light-gray px-3 py-2 text-sm font-normal text-neutral-subtle"
                        >
                          <img
                            class="mr-2 h-5 w-5"
                            src="@/assets/loads/triumph-logo-blue.svg"
                            alt="triumph logo"
                          />
                          QuickPay - {{ quickPayRate }}%
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      class="pb-4 pt-2"
                    >
                      <p class="text-sm text-steel-700">
                        Market Rate Unavailable
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="isLoadBoard && isDesktop"
                    class="mt-4 rounded-lg border border-light-gray p-3"
                  >
                    <p class="pb-2 text-left text-xl font-medium">Details</p>

                    <div class="flex flex-col gap-2 pb-2">
                      <div
                        v-if="load?.last_posted_at"
                        class="flex justify-between"
                      >
                        <p class="text-neutral-subtlest">Post Age</p>
                        <p class="text-steel-900">
                          {{ fromNowFirstUnit(load.last_posted_at) }}
                        </p>
                      </div>

                      <div class="flex justify-between">
                        <p class="text-neutral-subtlest">Weight</p>
                        <p class="text-steel-900">
                          {{ loadWeight }}
                        </p>
                      </div>

                      <!-- <div class="flex justify-between">
                        <p class="text-neutral-subtlest">Commodity</p>
                        <p class="text-steel-900">
                          {{ load?.posted_commodity_type || '-' }}
                        </p>
                      </div> -->

                      <div
                        v-if="
                          load?.is_hazmat_required || load?.is_teams_required
                        "
                        class="flex justify-between"
                      >
                        <p class="text-neutral-subtlest">Type</p>

                        <div
                          class="flex max-w-[300px] flex-wrap justify-end gap-2"
                        >
                          <span
                            v-if="load?.is_hazmat_required"
                            class="text-neutral-bold rounded-md bg-steel-100 px-2 py-[2px] text-sm text-xs capitalize"
                          >
                            Hazmat
                          </span>
                          <span
                            v-if="load?.is_teams_required"
                            class="text-neutral-bold rounded-md bg-steel-100 px-2 py-[2px] text-sm text-xs capitalize"
                          >
                            Teams
                          </span>
                        </div>
                      </div>

                      <div
                        v-if="load?.comments"
                        class="flex flex-col items-start gap-2"
                      >
                        <p class="text-neutral-subtlest">
                          Special Instructions
                        </p>
                        <p class="text-left text-steel-900">
                          {{ load?.comments }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="isLoadBoard && isDesktop"
                    class="mt-4 flex flex-col"
                  >
                    <div class="rounded-lg border border-light-gray p-3">
                      <p class="mb-2 text-left text-xl font-medium">
                        Equipment
                      </p>

                      <div class="mb-2 flex flex-col gap-2 font-normal">
                        <!-- <div class="col-span-3 flex items-center justify-between">
                          <p class="text-neutral-subtlest">Load Type</p>
                          <p class="text-steel-900">LTL</p>
                        </div> -->

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Truck Type</p>

                          <p class="text-steel-900">
                            {{
                              formatEquipmentType(
                                load?.posted_equipment_types
                              ) || '-'
                            }}
                          </p>
                        </div>

                        <div
                          v-if="
                            load.posted_equipment_types !== undefined &&
                            load?.posted_equipment_types.includes('reefer') &&
                            (load?.temperature_min || load?.temperature_max)
                          "
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Temperature Range</p>
                          <p class="text-steel-900">
                            {{ load?.temperature_min }}&deg;{{
                              load.temperature_unit == 'fahrenheit' ? 'F' : 'C'
                            }}
                            - {{ load?.temperature_max }}&deg;{{
                              load.temperature_unit == 'fahrenheit' ? 'F' : 'C'
                            }}
                          </p>
                        </div>

                        <div
                          v-if="load?.trailer_length"
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Length</p>

                          <p class="text-steel-900">
                            {{ trailerLength }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4">
                      <div
                        v-for="(stop, stopIndex) in load.stops"
                        :key="stop.id"
                        class="border border-light-gray p-3"
                        :class="{
                          'rounded-t-lg': stopIndex === 0,
                          'rounded-b-lg': stopIndex === load.stops?.length - 1,
                        }"
                      >
                        <p class="mb-2 text-left text-xl font-medium">
                          Stop {{ stopIndex + 1 }}
                        </p>

                        <div class="flex flex-col gap-2 font-normal">
                          <div
                            class="col-span-3 flex items-center justify-between"
                          >
                            <p class="text-neutral-subtlest">Type</p>
                            <p class="text-steel-900">
                              {{
                                stop.trailer_operation_type == 'loading'
                                  ? 'Loading'
                                  : 'Unloading'
                              }}
                            </p>
                          </div>

                          <div
                            class="col-span-3 flex items-center justify-between"
                          >
                            <p class="text-neutral-subtlest">Location</p>

                            <p class="text-steel-900">
                              {{ formattedCityStateAddress(stop) }}
                            </p>
                          </div>

                          <div
                            class="col-span-3 flex items-center justify-between"
                          >
                            <p class="text-neutral-subtlest">Appointment</p>
                            <p class="text-steel-900">
                              {{ formatStopWindow(stop) }}
                            </p>
                          </div>

                          <div
                            v-if="stop?.comments"
                            class="flex flex-col items-start gap-2"
                          >
                            <p class="text-neutral-subtlest">Comments</p>
                            <p class="text-left text-steel-900">
                              {{ stop?.comments }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="z-10 -mt-8 rounded-xl border border-light-gray bg-white p-4 shadow-md lg:mt-4"
              >
                <router-link
                  v-if="brokerLogo && broker?.carrier_id"
                  :to="{
                    name: 'Carrier Brokers Show Page',
                    params: { id: broker?.carrier_id },
                  }"
                  target="_blank"
                  class="flex items-center justify-center gap-2"
                >
                  <img
                    class="flex h-8 items-center text-2xs"
                    :src="brokerLogo"
                    alt="broker logo"
                  />
                </router-link>

                <div class="mt-4 flex items-center justify-around">
                  <div
                    v-if="billableMiles"
                    class="flex gap-1"
                  >
                    <img
                      src="@/assets/loads/map.svg"
                      alt="map icon"
                    />
                    <p class="text-xs">{{ billableMiles }}mi Trip</p>
                  </div>
                  <div class="flex items-center gap-1">
                    <img
                      class="h-5 w-5"
                      src="@/assets/loads/destination-marker.svg"
                      alt="destination icon"
                    />
                    <p class="text-xs">
                      {{ numberOfStops }}
                    </p>
                  </div>
                  <!-- <div class="flex gap-1">
                    <img
                      src="@/assets/phone-arrow.svg"
                      alt="phone icon"
                    />
                    <a
                      class="text-xs"
                      href="tel:+1234567890"
                      >{{ formattedPhone }}</a
                    >
                  </div> -->
                </div>
              </div>

              <div
                v-if="isLoadBoard && !isDesktop"
                :class="{
                  'flex flex-col gap-1.5 rounded-xl border border-light-gray bg-white py-2 shadow-md lg:mt-4':
                    !isDesktop,
                }"
              >
                <p
                  class="border-gray border-b pb-2 pl-4 text-left text-xl font-medium"
                >
                  Details
                </p>

                <div class="flex flex-col gap-1.5 px-4 py-2">
                  <div
                    v-if="load.last_posted_at"
                    class="flex justify-between"
                  >
                    <p class="text-neutral-subtlest">Post Age</p>
                    <p class="text-steel-900">
                      {{ fromNowFirstUnit(load.last_posted_at) }}
                    </p>
                  </div>

                  <div class="flex justify-between">
                    <p class="text-neutral-subtlest">Weight</p>
                    <p class="text-steel-900">
                      {{ loadWeight }}
                    </p>
                  </div>

                  <!-- <div class="flex justify-between">
                    <p class="text-neutral-subtlest">Commodity</p>
                    <p class="text-steel-900">
                      {{ load?.posted_commodity_type || '' }}
                    </p>
                  </div> -->

                  <div
                    v-if="load?.is_hazmat_required || load?.is_teams_required"
                    class="flex justify-between"
                  >
                    <p class="text-neutral-subtlest">Type</p>

                    <div class="flex max-w-[300px] flex-wrap justify-end gap-2">
                      <span
                        v-if="load?.is_hazmat_required"
                        class="text-neutral-bold rounded-md bg-steel-100 px-2 py-[2px] text-sm text-xs capitalize"
                      >
                        Hazmat
                      </span>
                      <span
                        v-if="load?.is_teams_required"
                        class="text-neutral-bold rounded-md bg-steel-100 px-2 py-[2px] text-sm text-xs capitalize"
                      >
                        Teams
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="load?.comments"
                    class="flex flex-col items-start gap-2"
                  >
                    <p class="text-neutral-subtlest">Special Instructions</p>
                    <p class="text-left text-steel-900">
                      {{ load?.comments }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="!isLoadBoard && isDesktop"
                class="mt-4"
              >
                <div
                  v-for="(stop, stopIndex) in load.stops"
                  :key="stop.id"
                  class="border border-light-gray p-3"
                  :class="{
                    'rounded-t-lg': stopIndex === 0,
                    'rounded-b-lg': stopIndex === load.stops?.length - 1,
                  }"
                >
                  <p class="mb-2 text-left text-xl font-medium">
                    Stop {{ stopIndex + 1 }}
                  </p>

                  <div class="flex flex-col gap-2 font-normal">
                    <div class="col-span-3 flex items-center justify-between">
                      <p class="text-neutral-subtlest">Type</p>

                      <p
                        v-if="!stopIndex"
                        class="text-steel-900"
                      >
                        Loading
                      </p>
                      <p
                        v-else
                        class="text-steel-900"
                      >
                        Unloading
                      </p>
                    </div>

                    <div class="col-span-3 flex items-center justify-between">
                      <p class="text-neutral-subtlest">Location</p>

                      <p class="text-steel-900">
                        {{ formattedCityStateAddress(stop) }}
                      </p>
                    </div>

                    <div class="col-span-3 flex items-center justify-between">
                      <p class="text-neutral-subtlest">Appointment</p>

                      <p class="text-steel-900">
                        {{ formattedTime(stop) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <CollapsibleLoadDetails
                v-if="!isLoadBoard && load?.assignment_eligible"
                title="Equipment"
              >
                <div
                  class="flex h-[180px] flex-col justify-center gap-2 border-t border-light-gray p-3 pb-1 font-normal"
                >
                  <div
                    v-if="load.carrier_vehicle?.id"
                    class="flex flex-col gap-1"
                  >
                    <div class="flex justify-between">
                      <p class="text-gray-600 sm:font-semibold">Truck Number</p>
                      <p>{{ load.carrier_vehicle?.truck_number || '-' }}</p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-gray-600 sm:font-semibold">VIN</p>
                      <div>
                        <p>{{ load.carrier_vehicle?.vin || '-' }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="flex h-fit flex-col items-center gap-2">
                    <img
                      src="@/assets/alert-square.svg"
                      alt="alert icon"
                    />
                    <p v-if="load.carrier_vehicle?.id">
                      Please confirm vehicle assignment for this load.
                    </p>
                    <p v-else>Please assign a vehicle to this load.</p>
                    <MyLoadsDesktopButtonComponent
                      :button-class="`${load.carrier_vehicle?.id ? 'secondary-button' : 'primary-button'} rounded-[5px] px-3 py-1 h-8`"
                      text-class="font-medium leading-10 tracking-tight text-sm capitalize"
                      :button-text="`${load.carrier_vehicle?.id ? 'Confirm' : 'Assign'} Vehicle`"
                      @button-click="showAssignVehicleModal = true"
                    />
                  </div>
                </div>
              </CollapsibleLoadDetails>
              <CollapsibleLoadDetails
                v-if="!isLoadBoard && !load?.assignment_eligible"
                title="Equipment"
              >
                <div
                  class="flex h-[100px] flex-col justify-center gap-2 border-t border-light-gray p-3 pb-1 font-normal"
                >
                  <div
                    v-if="load?.carrier_vehicle?.id"
                    class="flex flex-col gap-1"
                  >
                    <div class="flex justify-between">
                      <p class="text-gray-600 sm:font-semibold">Truck Number</p>
                      <p>{{ load.carrier_vehicle?.truck_number || '-' }}</p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-gray-600 sm:font-semibold">VIN</p>
                      <div>
                        <p>{{ load.carrier_vehicle?.vin || '-' }}</p>
                      </div>
                    </div>
                  </div>
                  <p v-else>No equipment listed for this load.</p>
                </div>
              </CollapsibleLoadDetails>

              <div v-if="!isDesktop">
                <CollapsibleLoadDetails
                  v-for="(stop, stopIndex) in load.stops"
                  :key="stop.id"
                  :title="`Stop ${stopIndex + 1}`"
                  :badge-text="
                    isLoadBoard ? '' : stopStatus(load.stops, stopIndex)?.status
                  "
                  :badge-color="
                    isLoadBoard ? '' : stopStatus(load.stops, stopIndex)?.color
                  "
                  :class-name="{
                    'mb-4': stopIndex !== load.stops?.length - 1,
                  }"
                >
                  <div
                    class="flex flex-col gap-2 border-t border-light-gray p-3 font-normal"
                  >
                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest sm:font-semibold">Type</p>
                      <p v-if="!stopIndex">Loading</p>
                      <p v-else>Unloading</p>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest sm:font-semibold">
                        Address
                      </p>
                      <div class="flex flex-col items-end">
                        <p v-if="!isLoadBoard">
                          {{ formattedStreetAddress(stop) }}
                        </p>
                        <p>{{ formattedCityStateAddress(stop) }}</p>
                      </div>
                    </div>

                    <div class="flex justify-between">
                      <p class="text-neutral-subtlest sm:font-semibold">
                        Appointment
                      </p>
                      <p class="text-steel-900">
                        {{ formatStopWindow(stop) }}
                      </p>
                    </div>
                  </div>
                </CollapsibleLoadDetails>
              </div>

              <CollapsibleLoadDetails
                v-if="!isLoadBoard"
                title="Broker"
                :class-name="!isDesktop ? 'mb-24' : ''"
              >
                <div
                  class="flex flex-col gap-2 border-t border-light-gray p-3 font-normal"
                >
                  <div class="flex justify-between">
                    <img
                      v-if="brokerLogo"
                      class="flex h-6 items-center text-2xs"
                      :src="brokerLogo"
                      alt="broker logo"
                    />
                  </div>
                  <div
                    v-if="load.broker?.legal_name"
                    class="flex items-center justify-between"
                  >
                    <p class="text-neutral-subtlest sm:font-semibold">Name</p>
                    <p class="text-steel-900">
                      {{ load.broker?.legal_name }}
                    </p>
                  </div>
                  <div
                    v-if="load.broker?.support_email"
                    class="flex items-center justify-between"
                  >
                    <p class="text-neutral-subtlest sm:font-semibold">Email</p>
                    <a
                      :href="`mailto:${load.broker?.support_email}`"
                      class="break-words text-sm font-medium leading-tight text-yellow-700 underline"
                    >
                      {{ load.broker?.support_email }}
                    </a>
                  </div>
                </div>
              </CollapsibleLoadDetails>

              <div
                v-if="isLoadBoard"
                class="flex flex-col gap-4"
                :class="{
                  'pb-24': !isDesktop,
                }"
              >
                <CollapsibleLoadDetails
                  v-if="isLoadBoard && !isDesktop"
                  title="Equipment"
                >
                  <div
                    class="flex flex-col gap-4 p-3 font-normal"
                    :class="{
                      'border-t border-light-gray': !isDesktop,
                    }"
                  >
                    <div
                      class="grid grid-cols-3 text-left"
                      :class="{
                        'gap-2': !isDesktop,
                      }"
                    >
                      <!-- <div
                        class="col-span-1 flex flex-col gap-1"
                        :class="{
                          'col-span-3 !flex-row justify-between': !isDesktop,
                        }"
                      >
                        <p class="text-neutral-subtlest sm:font-semibold">
                          Load Type
                        </p>
                        <p class="text-steel-900">LTL</p>
                      </div> -->

                      <div
                        class="col-span-1 flex flex-col gap-1"
                        :class="{
                          'col-span-3 !flex-row justify-between': !isDesktop,
                        }"
                      >
                        <p class="text-neutral-subtlest sm:font-semibold">
                          Truck Type
                        </p>
                        <p class="text-steel-900">
                          {{
                            formatEquipmentType(load?.posted_equipment_types) ||
                            '-'
                          }}
                        </p>
                      </div>

                      <div
                        v-if="load?.trailer_length"
                        class="col-span-1 flex flex-col gap-1"
                        :class="{
                          'col-span-3 !flex-row justify-between': !isDesktop,
                        }"
                      >
                        <p class="text-neutral-subtlest sm:font-semibold">
                          Length
                        </p>
                        <p class="text-steel-900">
                          {{ trailerLength }}
                        </p>
                      </div>
                    </div>
                  </div>
                </CollapsibleLoadDetails>

                <div v-if="isDesktop">
                  <div
                    class="flex flex-col gap-2 rounded-lg border border-light-gray p-3 text-left"
                  >
                    <p class="text-left text-xl font-medium">Broker</p>

                    <div class="flex items-center justify-between">
                      <p class="text-neutral-subtlest">
                        {{
                          load.broker_name || load.order?.company?.legal_name
                        }}
                      </p>
                      <img
                        v-if="brokerLogo"
                        class="flex h-8 max-w-48 items-center text-2xs"
                        :src="brokerLogo"
                        alt="broker logo"
                      />
                    </div>

                    <div
                      class="flex !flex-row flex-col items-center justify-between gap-1"
                    >
                      <p class="text-neutral-subtlest">Connection Status</p>
                      <div class="flex items-center gap-1">
                        <p
                          v-if="isConnected"
                          class="text-steel-900"
                        >
                          You're Connected
                        </p>
                        <p
                          v-else
                          class="text-steel-900"
                        >
                          Not Connected
                        </p>
                      </div>
                    </div>

                    <div class="flex items-center justify-between">
                      <p class="text-neutral-subtlest">Phone Number</p>
                      <a
                        v-if="formattedPhone"
                        class="text-xs text-steel-900 underline sm:text-gold"
                        :href="`tel:+${load.broker_phone_number}`"
                      >
                        {{ formattedPhone }}
                      </a>
                      <p v-else>-</p>
                    </div>

                    <div class="flex items-center justify-between">
                      <p class="text-neutral-subtlest">Email</p>
                      <a
                        :href="`mailto:${load.broker_email}`"
                        class="text-xs text-steel-900"
                        :class="{
                          'underline sm:text-gold': load.broker_email,
                        }"
                      >
                        {{ load.broker_email || '-' }}</a
                      >
                    </div>
                  </div>
                </div>
                <div v-else>
                  <CollapsibleLoadDetails title="Broker">
                    <div
                      class="flex flex-col p-3 font-normal sm:gap-4"
                      :class="{
                        'border-t border-light-gray': !isDesktop,
                      }"
                    >
                      <div class="grid grid-cols-3 gap-2 text-left">
                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">
                            {{
                              load.broker_name ||
                              load.order?.company?.legal_name
                            }}
                          </p>
                          <img
                            v-if="brokerLogo"
                            class="flex h-8 max-w-48 items-center text-2xs"
                            :src="brokerLogo"
                            alt="broker logo"
                          />
                        </div>

                        <div
                          class="col-span-1 col-span-3 flex !flex-row flex-col justify-between gap-1"
                        >
                          <p class="text-steel-900">Connection Status</p>
                          <div class="flex gap-1">
                            <p
                              v-if="isConnected"
                              class="text-steel-900"
                            >
                              You're Connected
                            </p>
                            <p
                              v-else
                              class="text-steel-900"
                            >
                              Not Connected
                            </p>
                          </div>
                        </div>

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Phone Number</p>
                          <a
                            v-if="formattedPhone"
                            class="text-xs text-steel-900 underline sm:text-gold"
                            :href="`tel:+${load.broker_phone_number}`"
                          >
                            {{ formattedPhone }}
                          </a>
                          <p v-else>-</p>
                        </div>

                        <div
                          class="col-span-3 flex items-center justify-between"
                        >
                          <p class="text-neutral-subtlest">Email</p>
                          <a
                            :href="`mailto:${load.broker_email}`"
                            class="text-xs text-steel-900 underline sm:text-gold"
                          >
                            {{ load.broker_email }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </CollapsibleLoadDetails>
                </div>

                <TriumphCollapsibleDetail
                  v-if="isLoadBoard"
                ></TriumphCollapsibleDetail>
              </div>
            </div>
          </div>
          <div
            v-if="isLoadBoard"
            class="mt-2 flex justify-end gap-2"
            :class="{
              'fixed bottom-0 left-0 z-30 w-full bg-white px-4 pb-8 pt-4':
                !isDesktop,
              'sticky bottom-0 left-0 z-30 mt-4 w-full border-t border-light-gray bg-white py-6 pr-6':
                isDesktop,
              'pb-14': showBanner,
            }"
          >
            <!-- <ButtonComponent
              v-if="load?.broker_phone_number && !isDesktop"
              :class="{
                'flex flex-1 justify-center': !isDesktop,
              }"
            >
              <a :href="`tel:+${load.broker_phone_number}`"> Contact Broker </a>
            </ButtonComponent> -->
            <div
              class="flex gap-4"
              :class="{
                'w-full flex-col': !isDesktop,
              }"
            >
              <div
                class="flex"
                :class="{
                  'gap-4': isDesktop,
                  'gap-2': !isDesktop,
                }"
              >
                <ButtonComponent
                  class="flex min-w-max justify-center"
                  :class="{
                    'py-4': !isDesktop,
                    'flex-1': isConnected && supportsPlaceOfferOrBookNowModal,
                    'w-full': !(
                      isConnected && supportsPlaceOfferOrBookNowModal
                    ),
                  }"
                  @click="openContactBrokerBottomSheet"
                >
                  Contact Broker
                </ButtonComponent>
                <ButtonComponent
                  v-if="
                    isConnected &&
                    supportsPlaceOfferOrBookNowModal &&
                    bookNowPreview &&
                    !placed_offer
                  "
                  variant="secondary"
                  class="flex min-w-max flex-1 justify-center"
                  :class="{
                    'py-4': !isDesktop,
                  }"
                  @click="handleBookNow"
                >
                  {{ modalText }}
                </ButtonComponent>
              </div>
              <!-- <ButtonComponent
                v-if="isConnected && load?.supports_book_now"
                variant="primary"
                class="flex min-w-max flex-1 justify-center"
                :class="{
                  'py-4': !isDesktop,
                }"
                @click="handleBookNow"
              >
                Book Now
              </ButtonComponent> -->
              <ButtonComponent
                v-if="!isConnected"
                class="flex min-w-[100px] justify-center"
                :class="{
                  'py-4': !isDesktop,
                }"
                variant="primary"
                :disabled="is_connect_button_loading"
                @click="handleConnect"
              >
                <svg
                  v-if="is_connect_button_loading"
                  class="loading relative h-5 w-full"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
                    stroke="currentColor"
                    stroke-width="3"
                  />
                  <path
                    d="M16 1V7L20 4L16 1Z"
                    fill="currentColor"
                  />
                  <path
                    d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
                    stroke="currentColor"
                    stroke-width="3"
                  />
                </svg>
                <p v-else>Connect</p>
              </ButtonComponent>
            </div>
          </div>
        </div>

        <!-- history tab -->
        <div
          v-else
          class="mx-2 mt-4 min-h-[700px] rounded-md border-2 pb-12"
        >
          <div v-if="loadLogs?.length">
            <div class="flex w-full border-b-2 py-2 text-sm">
              <div class="flex-1">Date</div>
              <div class="flex-1">Location</div>
              <div class="flex-1">Update Type</div>
            </div>
            <div
              v-for="event in loadLogs"
              :key="event.id"
              class="flex w-full border-b-2 py-2 text-xs font-normal"
            >
              <div class="flex flex-1 justify-center gap-1">
                <svg
                  v-if="event.is_type === 'carrier_vehicle_assigned'"
                  class="-ml-5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 6.93543 14.4169 5.92921 13.9732 5.03655L7.55889 11.4508L3.95215 7.84406L5.29901 6.4972L7.55889 8.75707L12.8693 3.4467C11.6527 2.14611 9.9211 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z"
                    fill="#F8C612"
                  />
                </svg>

                <svg
                  v-if="event.is_type === 'arrived_at_stop'"
                  class="-ml-5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.99967 14.6666C9.33301 14.6666 12.6663 8.57725 12.6663 5.99992C12.6663 3.42259 10.577 1.33325 7.99967 1.33325C5.42235 1.33325 3.33301 3.42259 3.33301 5.99992C3.33301 8.57725 6.66634 14.6666 7.99967 14.6666ZM7.99967 7.33325C8.73605 7.33325 9.33301 6.7363 9.33301 5.99992C9.33301 5.26354 8.73605 4.66659 7.99967 4.66659C7.26329 4.66659 6.66634 5.26354 6.66634 5.99992C6.66634 6.7363 7.26329 7.33325 7.99967 7.33325Z"
                    fill="#F8C612"
                  />
                </svg>

                <svg
                  v-if="event.is_type === 'departed_stop'"
                  class="-ml-5"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.6"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.99967 8.00008C2.99967 6.44688 4.06199 5.1418 5.49967 4.77176C5.23333 4.70321 4.95409 4.66675 4.66634 4.66675C2.82539 4.66675 1.33301 6.15913 1.33301 8.00008C1.33301 9.84103 2.82539 11.3334 4.66634 11.3334C4.95409 11.3334 5.23333 11.297 5.49967 11.2284C4.06199 10.8584 2.99967 9.55328 2.99967 8.00008ZM6.33301 8.00008C6.33301 6.44688 7.39532 5.1418 8.83301 4.77176C8.56666 4.70321 8.28742 4.66675 7.99967 4.66675C6.15873 4.66675 4.66634 6.15913 4.66634 8.00008C4.66634 9.84103 6.15873 11.3334 7.99967 11.3334C8.28742 11.3334 8.56666 11.297 8.83301 11.2284C7.39532 10.8584 6.33301 9.55328 6.33301 8.00008Z"
                    fill="#4285D7"
                  />
                  <ellipse
                    cx="11.3333"
                    cy="8.00008"
                    rx="3.33333"
                    ry="3.33333"
                    fill="#4285D7"
                  />
                </svg>

                <div class="text-left">
                  <div>
                    {{ getStopDay(event.occurred_at) }}
                  </div>
                  <div>{{ getStopTime(event.occurred_at, '', false) }}</div>
                </div>
              </div>

              <div class="flex-1 items-center capitalize">
                {{
                  event.carrier_vehicle_area?.carrier_vehicle_areas[0]
                    ?.description || ''
                }}
              </div>

              <div class="flex-1 items-center pr-2 capitalize">
                {{ event.external_message }}
              </div>
            </div>

            <div class="mb-4 mt-3 flex flex-col items-center">
              <span
                v-if="loadLogs?.length >= 10"
                class="cursor-pointer border-b-2 border-transparent text-sm text-gray-over-dark hover:border-gray-over-dark"
                @click="handleViewAll"
              >
                View {{ viewAllHistoryLogs ? 'less' : 'all' }}
              </span>
            </div>
          </div>

          <div v-else>
            <p class="mt-4 px-4 text-start text-base italic text-gray-200">
              No load events have been logged.
            </p>
          </div>
        </div>
      </div>

      <LoadDetailMap
        v-if="!isLoading && isDesktop"
        :is-desktop="isDesktop"
        :load="load"
      ></LoadDetailMap>
    </div>
    <TeleportModalWrapperComponent
      :margin-top="innerHeight < 700 ? 'mt-[60px]' : ''"
      :align="innerHeight < 700 ? 'start' : 'center'"
      :is-modal-open="showAssignVehicleModal"
    >
      <MyLoadsAssignVehicleModalComponent
        :external-load-id="load?.shipment_identifier"
        :origin="
          load?.stops?.length ? stopDetails(load.stops[0]) : { city: '-' }
        "
        :destination="
          load?.stops?.length > 1
            ? stopDetails(load.stops[load.stops.length - 1])
            : { city: '-' }
        "
        :action-type="selectedLoadActionType"
        :assigned-vehicle="selectedLoadAssignedVehicle"
        @close-modal="showAssignVehicleModal = false"
        @assign-vehicle="assignVehicle"
        @confirm-vehicle="handleConfirmVehicleClick"
        @open-view-equipment-modal="
          () => {
            showAssignVehicleModal = false;
            showEquipmentModal = true;
          }
        "
      />
    </TeleportModalWrapperComponent>
    <Teleport to="body">
      <DisplayEquipmentTableModal
        :visible="showEquipmentModal"
        :show-dismiss-button-prop="true"
        @close="
          () => {
            showEquipmentModal = false;
            showAssignVehicleModal = true;
          }
        "
      />
    </Teleport>

    <AssignVehicleBottomSheet
      :visible="showAssignVehicleBottomSheet"
      @close="closeAssignVehicleBottomSheet"
    >
    </AssignVehicleBottomSheet>

    <FactoringBottomSheet
      :visible="showFactoringBottomSheet"
      @close="closeFactoringBottomSheet"
    >
    </FactoringBottomSheet>

    <BookNowBottomSheet
      :visible="showBookNowBottomSheet"
      :load-id="load?.id"
      @close="closeBookNowBottomSheet"
    >
    </BookNowBottomSheet>
    <PlaceOfferBottomSheet
      :visible="showPlaceOfferBottomSheet"
      :offer="load"
      @close="closePlaceOfferBottomSheet"
    >
    </PlaceOfferBottomSheet>
    <ContactBrokerBottomSheet
      :visible="showContactBrokerBottomSheet"
      :contact-information="brokerContactInformation"
      @close="closeContactBrokerBottomSheet"
    >
    </ContactBrokerBottomSheet>
  </banners>
</template>

<script>
import { ref, computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';
import dayjs from 'dayjs';
import { ButtonComponent } from '@/components';
import Banners from '@/components/Banners.vue';
import {
  AssignVehicleBottomSheet,
  BookNowBottomSheet,
  PlaceOfferBottomSheet,
  CollapsibleLoadDetails,
  FactoringBottomSheet,
  LoadDetailMap,
  TriumphCollapsibleDetail,
  ContactBrokerBottomSheet,
} from '@/components/loads';
import { useScreenSize } from '@/composables/useScreenSize';
import { formatPhoneParenthesis } from '@/common/validators.js';
import { fromNowFirstUnit } from '@/common/timestamps';
import { formatPrice } from '@/utils/currency.js';
import {
  getAppointmentDate,
  getStopDay,
  getStopTime,
} from '@/utils/loadTime.js';
import {
  formattedStreetAddress,
  formattedCityStateAddress,
  formatLoadStatus,
  formatEquipmentType,
  capitalizeWords,
  formatStopDate,
  formatStopWindow,
} from '@/utils/loadBoardUtils.js';
import MyLoadsAssignVehicleModalComponent from '@/components/myLoads/MyLoadsDesktopAssignVehicleModalComponent.vue';
import TeleportModalWrapperComponent from '@/components/TeleportModalWrapperComponent.vue';
import DisplayEquipmentTableModal from '@/components/modals/displayEquipmentTableModal.vue';
import MyLoadsDesktopButtonComponent from '@/components/myLoads/MyLoadsDesktopButtonComponent.vue';

export default {
  name: 'Load Detail View',
  components: {
    Banners,
    ButtonComponent,
    BookNowBottomSheet,
    CollapsibleLoadDetails,
    LoadDetailMap,
    AssignVehicleBottomSheet,
    TriumphCollapsibleDetail,
    FactoringBottomSheet,
    MyLoadsAssignVehicleModalComponent,
    TeleportModalWrapperComponent,
    DisplayEquipmentTableModal,
    MyLoadsDesktopButtonComponent,
    PlaceOfferBottomSheet,
    ContactBrokerBottomSheet,
  },
  methods: {
    formattedTime(stop) {
      const { time, day } = getAppointmentDate(stop);

      return `${day}, ${time}`;
    },
    wasLoadCreatedAfterStopAppt(stop) {
      if (stop.scheduled_window_ended_at_in_stop_timezone) {
        return (
          Date.parse(stop.created_at) >
          Date.parse(stop.scheduled_window_ended_at_in_stop_timezone)
        );
      }
      return false;
    },
    hasIncompleteStopAddress(stop) {
      if (stop.street1?.length) {
        return false;
      }
      return true;
    },
    stopStatus(stops, index) {
      const stop = stops[index];

      if (stop.departed_at_in_stop_timezone) {
        return { status: 'Departed', color: 'green' };
      } else if (stop.arrived_at_in_stop_timezone) {
        return { status: 'Arrived', color: 'green' };
      } else if (this.wasLoadCreatedAfterStopAppt(stop)) {
        return {
          // status: 'Unknown Stop Status: Load Data Received Late',
          status: 'Unknown Stop Status',
          color: 'gray',
        };
      } else if (this.hasIncompleteStopAddress(stop)) {
        return {
          // status: 'Unknown Stop Status: No Street Address Provided',
          status: 'Unknown Stop Status',
          color: 'gray',
        };
      } else if (
        (index === 0 &&
          !stops[index + 1]?.arrived_at_in_stop_timezone &&
          !stops[index + 1]?.departed_at_in_stop_timezone) ||
        (index !== 0 &&
          (stops[index - 1]?.departed_at_in_stop_timezone ||
            this.wasLoadCreatedAfterStopAppt(stops[index - 1])))
      ) {
        return { status: 'En Route', color: 'light-blue' };
      } else {
        return { status: 'Not Started', color: 'gray' };
      }
    },
    getHighwayStatus(id) {
      if (id !== null && id > 0) {
        return 'Connected';
      } else {
        return 'Not Connected';
      }
    },
    canConnect() {
      return (
        this.$store.state.users?.currentUser?.company?.company_type ==
          'broker' && this.$store.state.users?.currentUser?.paywall?.can_connect
      );
    },
  },
  setup() {
    const { innerHeight } = useScreenSize();
    const showAssignVehicleModal = ref(false);

    const isLoadingAssignedVehicle = ref(false);

    const showEquipmentModal = ref(false);
    const store = useStore();
    const router = useRouter();
    const toast = useToast();
    const { screenSize } = useScreenSize();

    const isLoading = ref(false);
    const currentTab = ref('Details');

    const canViewLoads = computed(() =>
      store.state.users?.currentUser?.scopes?.includes(
        'carrier_view_posted_loads'
      )
    );
    const isLoadBoard = ref(false);

    const showAssignVehicleBottomSheet = ref(false);
    const isDesktop = computed(() => screenSize.value === 'desktop');

    const openAssignVehicleBottomSheet = () => {
      showAssignVehicleBottomSheet.value = true;
    };

    const closeAssignVehicleBottomSheet = () => {
      showAssignVehicleBottomSheet.value = false;
    };

    const showFactoringBottomSheet = ref(false);
    const openFactoringBottomSheet = () => {
      showFactoringBottomSheet.value = true;
    };
    const closeFactoringBottomSheet = () => {
      showFactoringBottomSheet.value = false;
    };

    const showBookNowBottomSheet = ref(false);
    const openBookNowBottomSheet = () => {
      showBookNowBottomSheet.value = true;
    };
    const closeBookNowBottomSheet = () => {
      showBookNowBottomSheet.value = false;
    };

    const showPlaceOfferBottomSheet = ref(false);
    const openPlaceOfferBottomSheet = () => {
      showPlaceOfferBottomSheet.value = true;
    };
    const closePlaceOfferBottomSheet = () => {
      showPlaceOfferBottomSheet.value = false;
    };

    const showContactBrokerBottomSheet = ref(false);
    const openContactBrokerBottomSheet = () => {
      showContactBrokerBottomSheet.value = true;
    };
    const closeContactBrokerBottomSheet = () => {
      showContactBrokerBottomSheet.value = false;
    };

    const brokerContactInformation = computed(() => ({
      name: load?.value?.broker_name,
      phone_number: load?.value?.broker_phone_number,
      email: load?.value?.broker_email,
    }));

    const backUrl = computed(() => {
      if (isLoadBoard?.value) {
        return router.options.history.state.back || '/carrier/load-board';
      } else {
        return router.options.history.state.back || '/carrier/loads';
      }
    });

    onBeforeMount(async () => {
      isLoading.value = true;

      const loadId = parseInt(router?.currentRoute?.value?.params?.id);

      let res;
      let navigateBack = false;
      let navigateRouteName = 'My Loads';
      let errorMessage;
      if (canViewLoads?.value) {
        const isPreLoaded = store.state.loads?.preloaded_load_response?.id;

        let loadBoardRes;
        let loadDetailRes;
        if (isPreLoaded) {
          isLoading.value = false;
          isLoadBoard.value = true;

          // Can assume load board details, is coming from TFX
          const [loadBoardDetailRes] = await Promise.all([
            store.dispatch('loads/getLoadBoardDetail', {
              id: loadId,
              quiet: !!isPreLoaded,
            }),
            store.dispatch('brokers/getBrokers', {}),
            store.dispatch('loads/getOfferByLoadId', { load_id: loadId }),
          ]);

          loadBoardRes = loadBoardDetailRes;
        } else {
          // If has canViewLoads scope
          // check if load is a posted load, otherwise grab load detail
          const [loadBoardDetailRes, loadDetailResponse] = await Promise.all([
            store.dispatch('loads/getLoadBoardDetail', {
              id: loadId,
              quiet: !!isPreLoaded,
            }),
            store.dispatch('loads/getLoadDetail', {
              id: loadId,
              query: 'carrier_show',
              quiet: !!isPreLoaded,
            }),
            store.dispatch('brokers/getBrokers', {}),
            store.dispatch('loads/getOfferByLoadId', { load_id: loadId }),
          ]);

          loadBoardRes = loadBoardDetailRes;
          loadDetailRes = loadDetailResponse;
        }

        if (loadBoardRes?.data) {
          isLoadBoard.value = true;
          res = loadBoardRes;

          if (!loadBoardRes?.data?.id && loadDetailRes?.data?.id) {
            isLoadBoard.value = false;
            res = loadDetailRes;
          }

          const userNotAuthorized =
            ([404, 400, 403, 429].includes(loadBoardRes?.status) ||
              !loadBoardRes?.data?.can_be_posted) &&
            !loadDetailRes?.data;

          if (userNotAuthorized) {
            navigateBack = true;
            navigateRouteName = 'Load Board';

            if (res?.status === 403) {
              errorMessage = 'Unauthorized access';
            } else if (res?.data?.error?.message) {
              errorMessage = res?.data?.error?.message;
            }
          }
        } else {
          res = loadDetailRes;

          if ([404, 400].includes(loadDetailRes?.status)) {
            navigateBack = true;
          }
        }
      } else {
        const [loadDetailRes] = await Promise.all([
          store.dispatch('loads/getLoadDetail', {
            id: loadId,
            query: 'carrier_show',
          }),
        ]);

        res = loadDetailRes;

        if ([404, 400].includes(loadDetailRes?.status)) {
          navigateBack = true;
        }
      }

      if (navigateBack) {
        // load detail not found or load not posted
        // route to load board

        const message =
          res?.status === 429
            ? 'Maximum daily search limit exceeded'
            : errorMessage
              ? errorMessage
              : 'Invalid Load Posting';
        toast.open({
          message,
          type: 'error',
          duration: 5000,
          dismissible: true,
          position: 'top-right',
        });

        router.push({
          name: navigateRouteName,
        });
      }

      const company_id = res?.data?.broker?.id || res?.data?.broker_company_id;

      await store.commit('loads/setLoadDetail', res?.data);
      await store.dispatch('brokers/getCompanyById', company_id);

      isLoading.value = false;
    });

    const showBanner = computed(
      () =>
        !store.state.errors.forceHideErrorBanner &&
        store.state.errors.showErrorBanner
    );

    onBeforeUnmount(() => {
      if (isLoadBoard?.value) {
        store.commit('loads/setLoadDetail', {});
        store.commit('loads/setPreLoadResponse', {});
        store.commit('loads/setOffer', {});
      }
    });

    const load = computed(() => store.state.loads.load_details);
    const placed_offer = computed(() => store.state.loads?.offer);

    const handleWithdrawOffer = async () => {
      await store.dispatch('loads/withdrawOffer', {
        id: placed_offer?.value?.id,
      });
    };

    const selectedLoadAssignedVehicle = computed(
      () =>
        load.value.carrier_vehicle || {
          id: '',
          truck_number: '',
          vin: '',
        }
    );
    const handleConfirmVehicleClick = (
      carrierVehicleId = '',
      vehicleIdentifier = ''
    ) => {
      if (selectedLoadTicketId.value) {
        confirmVehicle();
      } else {
        assignVehicle(carrierVehicleId, vehicleIdentifier);
      }
    };
    const assignVehicle = async (
      carrierVehicleId = '',
      vehicleIdentifier = ''
    ) => {
      isLoadingAssignedVehicle.value = true;
      showAssignVehicleModal.value = false;
      if (carrierVehicleId.length === 0) {
        toast.open({
          message: 'Please select a vehicle with valid id to assign.',
          type: 'error',
          position: 'top-right',
          duration: 2000,
        });
        return;
      }
      const payload = {
        carrier_vehicle_id: carrierVehicleId,
      };
      const res = await store.dispatch('myLoadsStore/patchMyLoad', {
        id: load.value.id,
        payload: payload,
      });
      isLoadingAssignedVehicle.value = false;
      if ([403, 422].includes(res.status)) {
        toast.open({
          message: `Error: ${res.status === 403 ? 'Not Authorized to update vehicle' : res.response?.data?.error || 'Assigned vehicle not updated. Please try again.'}`,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        });
        return;
      }
      if ([200, 201, 204].includes(res.status)) {
        showAssignVehicleModal.value = false;
        toast.open({
          message:
            'Assigned vehicle successfully updated to ' + vehicleIdentifier,
          position: 'top-right',
          // type: 'info',
          duration: 1500,
        });
        // update row in table
      } else {
        isLoadingAssignedVehicle.value = false;
        toast.open({
          message: `Error: ${res.response?.data?.error || 'Assigned vehicle not updated. Please try again.'}`,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        });
      }
    };
    const confirmVehicle = async () => {
      isLoadingAssignedVehicle.value = true;
      showAssignVehicleModal.value = false;
      if (!selectedLoadTicketId.value) {
        toast.open({
          message: 'Unable to confirm vehicle please try again.',
          type: 'error',
          position: 'top-right',
          duration: 2000,
        });
        return;
      }
      let res = null;
      try {
        res = await store.dispatch(
          'myLoadsStore/patchCloseAlert',
          selectedLoadTicketId.value
        );
      } catch (error) {
        isLoadingAssignedVehicle.value = false;
        toast.open({
          message: `Error: ${error.status == 403 ? 'Not Authorized to confirm vehicle' : error.response?.data?.error || 'Assigned vehicle not confirmed. Please try again.'}`,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        });
        return;
      }
      if ([200, 201, 204].includes(res.status)) {
        showAssignVehicleModal.value = false;
        toast.open({
          message: 'Assigned vehicle successfully confirmed',
          position: 'top-right',
          // type: 'info',
          duration: 1500,
        });
      } else {
        isLoadingAssignedVehicle.value = false;
        toast.open({
          message: `Error: ${res.response?.data?.error || 'Assigned vehicle not updated. Please try again.'}`,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        });
      }
    };
    const loadDetailsLoading = computed(
      () => store.state.loads.isLoadDetailsLoading
    );
    const assignedVehicle = computed(() => store.state.loads.assigned_vehicle);

    const broker_connections = computed(() => store.state.brokers.connections);

    const load_connection = computed(() =>
      broker_connections?.value?.find(
        (connection) =>
          connection?.company_id === load?.value?.broker_company_id
      )
    );

    const isConnected = computed(
      () => load_connection?.value?.status === 'onboarded'
    );

    const viewAllHistoryLogs = ref(false);

    const handleViewAll = () => {
      viewAllHistoryLogs.value = !viewAllHistoryLogs.value;
    };

    const stopDetails = (stop) => {
      if (!stop) {
        return false;
      }
      return {
        id: stop.id,
        street1: capitalizeWords(stop.street1),
        street2: capitalizeWords(stop.street2),
        city: capitalizeWords(stop.city) || stop.area_five_zip_city || '',
        state: stop.state || stop.area_five_zip_state || '',
        zip: stop.postal_code || '',
        appointmentDay: getStopDay(
          stop.scheduled_window_started_at_in_stop_timezone ||
            stop.scheduled_window_ended_at_in_stop_timezone,
          stop.timezone,
          { monthNumeric: true, yearDigits: 2, includesYear: false }
        ),
        appointmentTime: getStopTime(
          stop.scheduled_window_started_at_in_stop_timezone ||
            stop.scheduled_window_ended_at_in_stop_timezone,
          stop.timezone
        ),
        arrivalDay: getStopDay(stop.arrived_at_in_stop_timezone, stop.timezone),
        arrivalTime: getStopTime(
          stop.arrived_at_in_stop_timezone,
          stop.timezone
        ),
        departureDay: getStopDay(
          stop.departed_at_in_stop_timezone,
          stop.timezone
        ),
        departureTime: getStopTime(
          stop.departed_at_in_stop_timezone,
          stop.timezone
        ),
      };
    };

    const lane_prediction = computed(() => load?.value?.lane_prediction);

    const quickPayRate = computed(
      () => load?.value?.triumph_financing_terms?.quick_pay?.rate
    );

    const loadLogs = computed(() => {
      if (viewAllHistoryLogs.value) {
        return store.state.loads.load_logs;
      } else {
        return store.state.loads.load_logs.slice(0, 10);
      }
    });

    const broker = computed(() => store.state.brokers?.company);
    const brokerLogo = computed(() => load?.value?.broker_logo?.url);

    const billableMiles = computed(() => {
      const totalMiles = load?.value?.posted_miles;

      if (!totalMiles) {
        return null;
      }

      return (Math.round(totalMiles * 100) / 100)?.toLocaleString();
    });

    const formattedPhone = computed(() => {
      return formatPhoneParenthesis(load?.value?.broker_phone_number);
    });

    const numberOfStops = computed(() => {
      if (load?.value?.number_of_stops) {
        return `${load?.value?.number_of_stops} Stops`;
      } else if (load?.value?.stops?.length === 0) {
        return '';
      } else if (load?.value?.stops?.length === 1) {
        return '1 Stop';
      } else {
        return `${load?.value?.stops?.length} Stops`;
      }
    });

    const handleTabSelection = async (tab) => {
      isLoading.value = true;
      currentTab.value = tab;

      isLoading.value = false;
    };

    const bookNowPreview = computed(
      () => store.state.users.featureFlags?.book_now_preview?.enabled
    );

    const supportsPlaceOfferOrBookNowModal = computed(() => {
      if (!load?.value?.price) {
        return load?.value?.supports_carrier_offers;
      }

      return (
        load?.value?.supports_carrier_offers || load?.value?.supports_book_now
      );
    });

    const modalText = computed(() => {
      if (
        !load?.value?.supports_carrier_offers ||
        !load?.value?.supports_book_now
      ) {
        if (load?.value?.supports_carrier_offers) {
          return 'Place Offer';
        }

        if (load?.value?.supports_book_now) {
          return 'Book Now';
        }
      }

      return 'Place Offer';
    });

    const handleBookNow = () => {
      openBookNowBottomSheet();

      // if (load?.value?.external_book_it_now_url) {
      //   window.location.href = load?.value?.external_book_it_now_url;
      // }
    };
    const handlePlaceOffer = () => {
      openPlaceOfferBottomSheet();
    };

    const is_connect_button_loading = computed(
      () => store.state.loads?.is_carrier_connect_button_loading
    );

    const handleConnect = async () => {
      console.log('Connect redirect');
      try {
        const response = await store.dispatch(
          'loads/sendCarrierToOnboarding',
          load?.value?.id
        );

        if (
          response?.response?.status === 422 &&
          response?.response?.data?.error === 'broker_onboarding_error'
        ) {
          toast.open({
            message:
              'Sorry, the broker you would like to connect with cannot currently onboard any new carriers',
            type: 'error',
            duration: 8000,
            dismissible: true,
            position: 'top-right',
          });
        } else {
          // Send user to onboarding
          window.location.href = `/monitor/api/v1/loads/${load?.value?.id}/send_carrier_to_onboarding`;
        }
      } catch (error) {
        console.log('Error: ', error);
      }
    };

    const handleChangeVehicle = () => {
      console.log('Change Vehicle');
    };

    const ratePerMile = computed(() => {
      return formatPrice(load?.value?.rate_per_mile);
    });

    const loadRate = computed(() => {
      return lane_prediction?.value?.posted_rate_assessment;
    });

    const loadRateClass = computed(() => {
      switch (loadRate?.value) {
        case 'Great':
          return 'bg-aqua-700 text-white';
        case 'Good':
          return 'bg-aqua-500 text-white';
        default:
          return '';
      }
    });

    const loadRateText = computed(() => {
      return null;
      // switch (loadRate?.value) {
      //   case 'Great':
      //     return 'Great Deal';
      //   case 'Good':
      //     return 'Good Deal';
      //   default:
      //     return null;
      // }
    });

    const weightUnit = {
      pound: 'lbs',
      kilogram: 'kg',
    };

    const loadWeight = computed(() => {
      if (!load?.value?.weight || load?.value?.weight === 0) {
        return '-';
      }

      return `${load?.value?.weight?.toLocaleString('en-US')} ${weightUnit[load?.value?.weight_unit]}`;
    });

    const lengthUnit = {
      inch: '"',
      foot: "'",
      meter: 'm',
    };

    const trailerLength = computed(
      () =>
        `${load?.value?.trailer_length}${lengthUnit[load?.value?.trailer_length_unit]}`
    );

    const targetRatePercentage = computed(() => {
      const { low_buy_rate, high_buy_rate } = lane_prediction?.value || {};

      if (high_buy_rate === low_buy_rate) return 0; // avoid division by zero
      const percentage =
        ((load?.value?.rate_per_mile - low_buy_rate) /
          (high_buy_rate - low_buy_rate)) *
        100;
      const clamp = Math.max(0, Math.min(100, percentage)); // clamp between 0 and 100
      return clamp;
    });

    const isBelowMarket = computed(() => {
      const { low_buy_rate, target_buy_rate } = lane_prediction?.value || {};

      if (target_buy_rate < low_buy_rate) {
        return true;
      }

      return false;
    });

    const isAboveMarket = computed(() => {
      const { high_buy_rate, target_buy_rate } = lane_prediction?.value || {};

      if (target_buy_rate > high_buy_rate) {
        return true;
      }

      return false;
    });

    const selectedLoadTicketId = computed(() => load.value.tickets?.[0]?.id);
    const selectedLoadActionType = computed(() =>
      selectedLoadTicketId.value ? 'confirm' : 'assign'
    );

    return {
      stopDetails,
      handleConfirmVehicleClick,
      confirmVehicle,
      selectedLoadActionType,
      innerHeight,
      showAssignVehicleModal,
      selectedLoadAssignedVehicle,
      showEquipmentModal,
      assignVehicle,
      isLoadingAssignedVehicle,
      backUrl,
      load,
      loadLogs,
      handleViewAll,
      viewAllHistoryLogs,
      broker,
      brokerLogo,
      billableMiles,
      assignedVehicle,
      formattedPhone,
      numberOfStops,
      isLoading,
      currentTab,
      handleTabSelection,
      showAssignVehicleBottomSheet,
      openAssignVehicleBottomSheet,
      closeAssignVehicleBottomSheet,
      showFactoringBottomSheet,
      openFactoringBottomSheet,
      closeFactoringBottomSheet,
      getStopDay,
      getStopTime,
      isDesktop,
      isLoadBoard,
      handleBookNow,
      handleChangeVehicle,
      formatPrice,
      fromNowFirstUnit,
      ratePerMile,
      loadRate,
      loadRateClass,
      loadRateText,
      loadWeight,
      trailerLength,
      formattedStreetAddress,
      formattedCityStateAddress,
      formatLoadStatus,
      formatEquipmentType,
      capitalizeWords,
      loadDetailsLoading,
      targetRatePercentage,
      isBelowMarket,
      isAboveMarket,
      lane_prediction,
      load_connection,
      formatStopDate,
      formatStopWindow,
      showBanner,
      isConnected,
      handleConnect,
      quickPayRate,
      is_connect_button_loading,
      showBookNowBottomSheet,
      openBookNowBottomSheet,
      closeBookNowBottomSheet,
      showPlaceOfferBottomSheet,
      openPlaceOfferBottomSheet,
      closePlaceOfferBottomSheet,
      showContactBrokerBottomSheet,
      openContactBrokerBottomSheet,
      closeContactBrokerBottomSheet,
      brokerContactInformation,
      handlePlaceOffer,
      bookNowPreview,
      supportsPlaceOfferOrBookNowModal,
      modalText,
      placed_offer,
      dayjs,
      handleWithdrawOffer,
    };
  },
};
</script>
